export default {
  custom: {
    label: 'カスタムプレイ広告',
    version: {
      table: {
        name: 'プロジェクト名',
        creator: 'クリエイター',
      },
      apply: {
        label: 'プッシュアカウントのみ',
        delete: {
          label: 'アカウント情報を削除',
          describe: '削除後は元に戻せません。削除しますか？',
        },
      },
      batch: {
        selected: '選択された{num}項目',
        selectall: 'すべて選択',
        reverse: '反選択',
        cancel: 'すべて解除',
        apply: 'プッシュ',
        delete: '削除',
      },
    },
    describe:
      '私たちは高品質なクリエイティブのカスタマイズと多様なマーケティングプランニングサービスを提供し、さまざまなマーケティング目標とシーンに対応します。',
  },
}
